import type { State } from '../types';
import { stitchChangeKeyObjects } from './utils';
import type { CartProductSchema } from '../../types';

type ContainerOrProductId = NonNullable<CartProductSchema['containerId'] | CartProductSchema['id']>;

export function getActiveUserCountForContainerOrProductId({
  containerOrProductId,
  products,
  selectedProducts,
  newActiveUserCounts,
  estimatedUsersForRecurringBillEstimate,
}: {
  containerOrProductId: ContainerOrProductId;
  products: State['products'];
  selectedProducts: State['selectedProducts'];
  newActiveUserCounts: number[];
  estimatedUsersForRecurringBillEstimate?: State['estimatedUsersForRecurringBillEstimate'];
}) {
  const allProductsWithChanges = Object.values(stitchChangeKeyObjects(products, selectedProducts));
  const productsWithinCurrentContainer = allProductsWithChanges.filter(
    (product) => product.containerId === containerOrProductId || product.id === containerOrProductId
  );

  const allActiveUsers = productsWithinCurrentContainer.map((product) => {
    // this is required to display actual estimated users in the cart line items not for order placement
    // we should take the estimated users for the recurring bill estimate if it exists
    // https://hello.atlassian.net/wiki/spaces/COMITFO/pages/3403322557/Allow+users+column+to+edit+in+UOF+cart+page
    return Number(estimatedUsersForRecurringBillEstimate?.[product.id])
      ? Number(estimatedUsersForRecurringBillEstimate?.[product.id])
      : Number(product.activeUsers);
  });
  const maxOfActiveUsers = Math.max(...[...allActiveUsers, ...newActiveUserCounts]);

  return maxOfActiveUsers;
}
